import { render, staticRenderFns } from "./AccessSection.vue?vue&type=template&id=58c07e49&scoped=true"
import script from "./AccessSection.vue?vue&type=script&lang=js"
export * from "./AccessSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c07e49",
  null
  
)

export default component.exports